export const globalConfig = {
     dataSize: 'GB',
     defaultCurrency: process.env.REACT_APP_DEFAULT_CURRENCY_SYMBOL || '$',
     pageCount: 50,
     pagination_Previous:'Prev',
     pagination_Next:'Next',
     allowPhoneNumberLength:16,
     restrictProviders: [2, 3]
};

export const appName = process.env.REACT_APP_NAME;
export const appEnvironment = process.env.REACT_APP_ENVIRONMENT;

export const brandNames = {
    'data2go': 'Data2go: TAKE A BYTE',
    'data2go-iot': 'Data2go IOT',
    'awesim': 'AweSIM',
    'esimcrew': 'eSIMCrew',
    'esimlinks': 'eSIMLinks',
    'esimple': 'eSimple',
    'gopamwe': 'Gopamwe',
    'orzo': 'Orzo',
    'elefone': 'elefone',
    'briant': 'Briant Broadband',
    'pinoy': 'Pinoy eSIM'
};

export const getBrandName = (appName) => {
    if (!appName) return 'Data2go: TAKE A BYTE';
    const brand = brandNames[appName.toLowerCase()];
    if (brand) return brand;
    return appName.charAt(0).toUpperCase() + appName.slice(1);
};